import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import NavBar from '../NavBar/NavBar';
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import {
  Grid,
  List,
  ListItemText,
} from "@mui/material";
import { SliderComponent } from "../../Component/Component";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    label: 'San Francisco – Oakland Bay Bridge, United States',
    imgPath:
      'https://cdn.vox-cdn.com/thumbor/2V6dYMtY4mOs3N8Qyo8MLpepA20=/93x0:1600x1005/920x613/filters:focal(93x0:1600x1005):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/49112139/witcher3_en_wallpaper_wallpaper_10_1920x1200_1433327727.0.0.jpg',
  },
  {
    label: 'The Witcher 3',
    imgPath:
      'https://pbs.twimg.com/media/FTIN491VEAAA7eQ.jpg',
  },
  {
    label: 'San Francisco – Oakland Bay Bridge, United States',
    imgPath:
      'https://cdn.vox-cdn.com/thumbor/2V6dYMtY4mOs3N8Qyo8MLpepA20=/93x0:1600x1005/920x613/filters:focal(93x0:1600x1005):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/49112139/witcher3_en_wallpaper_wallpaper_10_1920x1200_1433327727.0.0.jpg',
  },
  {
    label: 'The Witcher 3',
    imgPath:
      'https://pbs.twimg.com/media/FTIN491VEAAA7eQ.jpg',
  },
];
const SliderLaunchpad = () => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Box>
          <Box sx={{ maxWidth: "100%", flexGrow: 1, margin: "5%" }}>
            <AutoPlaySwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={activeStep}
              onChangeIndex={handleStepChange}
              enableMouseEvents
            >
              {images.map((step, index) => (
                <div key={step.label}>
                  {Math.abs(activeStep - index) <= 2 ? (
                    <SliderComponent
                    sx={{
                      height: "500px",
                      display: "block",
                      overflow: "hidden",
                      objectFit: "cover",
                      width: "100%",
                    }}
                  >
                    <Box
                      component="img"
                      src={step.imgPath}
                      alt={step.label}
                      sx={{ objectFit: "cover", width: "100%", height: "100%" }}
                    />
                  </SliderComponent>
                  ) : null}
                </div>
              ))}
            </AutoPlaySwipeableViews>
          </Box>
          <Box
            sx={{
              position: "absolute",
              zIndex: 1,
              marginTop: "-20%",
              marginLeft: "4.2%",
              width: "70%",
            }}
          >
            <Box
              sx={{
                background:
                  "linear-gradient(115deg, rgba(25, 61, 87, 0.81) 0%, rgba(29, 43, 73, 0.56) 50%, rgba(33, 27, 60, 0.98) 100%)",
                borderRadius: " 0px 100px 100px 0px",
                height: "19%",
                width: "19%",
                marginTop: "12%",
                // marginLeft: "1.2%",
              }}
            >
              <List sx={{ marginLeft: "5%" }}>
                <ListItemText primary="FEATURED" sx={{ color: "#2f6df6" }} />
                <ListItemText primary="LAUNCH" sx={{ fontSize: "25px" }} />
              </List>
            </Box>
          </Box>

          <Box
            sx={{
              backgroundColor: "#0162ea",
              height: "76px",
              zIndex: "-1",
              marginTop: "-14%",
              marginLeft: "4%",
              width: "91.5%",
            }}
          ></Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SliderLaunchpad;
